import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Box, Fade, Paper, DialogActions } from '@material-ui/core'
import { FormLoader } from '../../../Loader/FormLoader'
import { formStyles } from '../FormStyles'
import { useStyles } from '../Styles'
import { useFormik } from 'formik'
import { CreateInvoiceStep2FormValidation } from '../../../../utils/validationSchema'
import Issuer from './Issuer'
import Receiver from './Receiver'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined'
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined'
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined'
import AddNewDialog from '../../../Dialog/AddNewDialog'
import AddressForm from './AddressForm'
import SaveInvoiceBtn from '../../SaveInvoiceBtn'

const InvoiceCreateStep2 = ({ taxpayerData, invoiceData, onSubmit, handleBackStep, locale, getReceiverDetails, currentReceiverDetails, resetReceiverDetails, inDialog, itemsAmount, handlePersonalLimitDialog, hasDrafted, handleSaveInvoiceEntity, savedTemplateData, invoicePersonalLimit }) => {
  const classes = useStyles()
  const formClasses = formStyles()

  const invoiceStep2Form = useFormik({
    initialValues: (!!Object.keys(invoiceData?.step2 || {}).length) ? {
      ...invoiceData.step2,
      itemsAmount: !!itemsAmount ? itemsAmount : (invoiceData?.step3?.calculatedTotalAmountEGP || invoiceData?.step3?.calculatedTotalAmount || 0),
      invoicePersonalLimit: invoicePersonalLimit
    } : {
      taxpayerActivityCode: taxpayerData?.branches?.length ? taxpayerData?.branches[0]?.activity_codes[0]?.code : '',
      issuerType: 'B',
      issuerID: taxpayerData?.trn || '',
      issuerName: taxpayerData?.name,
      issuerBranchID: taxpayerData?.branches?.length ? taxpayerData?.branches[0]?.branch_number : '',
      issuerAddress: {},
      receiverType: 'B',
      receiverID: '',
      receiverName: '',
      receiverBranchID: '',
      receiverAddress: {},
      itemsAmount: !!itemsAmount ? itemsAmount : (invoiceData?.step3?.calculatedTotalAmountEGP || invoiceData?.step3?.calculatedTotalAmount || 0),
      invoicePersonalLimit: invoicePersonalLimit
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    // isInitialValid: false,
    validationSchema: CreateInvoiceStep2FormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions, 'step2')
    })
  })

  const [isAddressDialogOpen, setIsAddressDialogOpen] = React.useState(false)
  const [isAddressDialogView, setIsAddressDialogView] = React.useState(false)
  const [currentAddressData, setCurrentAddressData] = React.useState({})
  const handleAddressDialog = (e, module) => {
    !!e?.preventDefault && e.preventDefault()
    !!e?.stopPropagation && e.stopPropagation()
    if (!isAddressDialogOpen) {
      if (!!module) {
        switch (module) {
          case 'Receiver':
            setCurrentAddressData({
              address: invoiceStep2Form.values.receiverAddress,
              fieldName: 'receiverAddress'
            })
            break
          case 'Issuer':
            setCurrentAddressData({
              address: invoiceStep2Form.values.issuerAddress,
              fieldName: 'issuerAddress'
            })
            break
          default:
            setCurrentAddressData({})
            break
        }
      }
      invoiceStep2Form?.setSubmitting(false)
      setIsAddressDialogView(true)
    } else {
      setTimeout(() => setIsAddressDialogView(false), 500)
    }
    setIsAddressDialogOpen(!isAddressDialogOpen)
  }
  const handleUpdateAddress = (values, fieldName) => {
    if (!!fieldName) {
      invoiceStep2Form.setFieldValue(fieldName, values)
      invoiceStep2Form.setFieldTouched(fieldName, true, false)
    }
    setTimeout(() => handleAddressDialog(), 500)
  }

  return (
    <Fade in={true}>
      <Paper elevation={4} className={classes.invoiceStepWrapper + ' step2' + (!!inDialog ? ' in-dialog' : '')}>
        {!inDialog &&
        <Issuer formActions={invoiceStep2Form} taxpayerData={taxpayerData} formClasses={formClasses}
                handleAddressDialog={handleAddressDialog} locale={locale} hasDrafted={hasDrafted}
                oldData={invoiceData?.step2}
                data={{
                  icon: <ArrowUpwardOutlinedIcon color={'primary'}/>,
                  title: <FormattedMessage id='InvoiceSteps.step2.Issuer.title'/>
                }}/>
        }
        <Receiver formActions={invoiceStep2Form} locale={locale} formClasses={formClasses} inDialog={inDialog}
                  handleAddressDialog={handleAddressDialog} getReceiverDetails={getReceiverDetails}
                  hasDrafted={hasDrafted} isExport={['EI','EC', 'ED'].includes(invoiceData?.step1?.documentType)}
                  currentReceiverDetails={currentReceiverDetails} resetReceiverDetails={resetReceiverDetails}
                  oldData={invoiceData?.step2} invoicePersonalLimit={invoicePersonalLimit}
                  data={{
                    icon: <ArrowDownwardOutlinedIcon color={'secondary'}/>,
                    title: <FormattedMessage id='InvoiceSteps.step2.Receiver.title'/>
                  }}/>

        {!!isAddressDialogView &&
        <AddNewDialog
          children={<AddressForm onSubmit={(values) => handleUpdateAddress(values, currentAddressData?.fieldName || '')}
                                 address={currentAddressData?.address || {}}
                                 isForeign={currentAddressData?.fieldName === 'receiverAddress' && invoiceStep2Form.values.receiverType === 'F'}
                                 isIssuer={currentAddressData?.fieldName === 'issuerAddress'}
                                 locale={locale} formClasses={formClasses}
                                 cancelDialog={handleAddressDialog}/>}
          DialogTitle={<FormattedMessage id={`${currentAddressData?.fieldName || 'Receiver'}.Address.Form.Title`}/>}
          isDialogOpen={isAddressDialogOpen}
          cancelDialog={handleAddressDialog}/>
        }

        {!!inDialog ?
          <DialogActions className={classes.dialogActionWrapper}>
            <div className={classes.dialogActionButtonsWrapper}>
              <Button variant='contained' color='secondary'
                      onClick={invoiceStep2Form.handleSubmit}
                      disabled={invoiceStep2Form.isSubmitting || !invoiceStep2Form.isValid}>
                <FormattedMessage id='invoiceSteps.button.submit'/>
              </Button>
              <Button variant='outlined' color='secondary'
                      onClick={handlePersonalLimitDialog}>
                <FormattedMessage id='AddNewDialog.Close'/>
              </Button>
            </div>
          </DialogActions> :
          <Box px={3} className={formClasses.FormSubmitRow + ' between'}>
            <Button variant={'outlined'} size={'large'} color={'secondary'}
                    className={formClasses.InvoiceStepGoBack} onClick={handleBackStep}>
              {locale === 'ar' ? <ArrowForwardIosOutlinedIcon/> : <ArrowBackIosOutlinedIcon/>}
              <FormattedMessage id='requestStep.button.previous'/>
            </Button>
            <div>
              {!!hasDrafted &&
              <SaveInvoiceBtn disabled={!!invoiceStep2Form.isSubmitting || !invoiceStep2Form.isValid}
                              savedTemplateData={savedTemplateData}
                              handleSaveInvoiceEntity={(e, entityType, tempData, formikActions, closeDialog) => handleSaveInvoiceEntity(e, entityType,
                                invoiceStep2Form.values, 'step2', tempData, formikActions, closeDialog)}/>
              }

              <Button type={'submit'} variant={'contained'} size={'large'} color={'secondary'}
                      onClick={invoiceStep2Form.handleSubmit}
                      disabled={invoiceStep2Form.isSubmitting || !invoiceStep2Form.isValid}
              >
                <FormattedMessage id='invoiceSteps.button.submit'/>
                {locale === 'ar' ? <ArrowBackIosOutlinedIcon/> : <ArrowForwardIosOutlinedIcon/>}
              </Button>
            </div>
          </Box>
        }
        {!!invoiceStep2Form.isSubmitting && <FormLoader loading={true}/>}
      </Paper>
    </Fade>
  )
}

export default InvoiceCreateStep2
